import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Clock, MessageCircle } from 'lucide-react';
import { PHONES, CONTACT } from '../content';

const INFO = [
  {
    icon: Phone,
    label: 'Ana Hat',
    value: PHONES.main,
    href: PHONES.main_tel,
    testid: 'contact-phone-link',
    color: 'var(--red)',
  },
  {
    icon: Phone,
    label: 'Hat 2',
    value: PHONES.secondary,
    href: PHONES.secondary_tel,
    color: 'var(--blue)',
  },
  {
    icon: Phone,
    label: 'Hat 3',
    value: PHONES.tertiary,
    href: PHONES.tertiary_tel,
    color: 'var(--green)',
  },
  {
    icon: Mail,
    label: 'E-Posta',
    value: CONTACT.email,
    href: `mailto:${CONTACT.email}`,
    color: '#ff9500',
  },
  {
    icon: Clock,
    label: 'Çalışma Saatleri',
    value: '7/24 — 365 Gün',
    note: 'Tatil günleri dahil',
    color: 'var(--blue)',
  },
  {
    icon: MapPin,
    label: 'Hizmet Bölgesi',
    value: 'Kocaeli Tüm İlçeler',
    note: '12+ ilçe kapsama',
    color: 'var(--green)',
  },
];

export default function ContactSection() {
  return (
    <section
      data-testid="contact-section"
      className="section"
      style={{
        background: 'var(--bg)',
        borderTop: '1px solid var(--border)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Glow */}
      <div
        style={{
          position: 'absolute',
          top: '25%',
          right: '15%',
          width: 500,
          height: 500,
          background: 'radial-gradient(ellipse, rgba(74,143,245,.05) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />

      <div className="wrap">
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <div className="pill" style={{ marginBottom: '1rem' }}>
            İletişim Bilgileri
          </div>
          <h2 className="h2" style={{ marginBottom: '.875rem' }}>
            Hemen <span style={{ color: 'var(--blue)' }}>Ulaşın</span>
          </h2>
          <p className="body" style={{ maxWidth: 480, margin: '0 auto', color: 'var(--text2)' }}>
            3 aktif telefon hattı, WhatsApp destek ve 7/24 canlı operatörle her an yanınızdayız.
          </p>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1.2fr',
            gap: '3rem',
            alignItems: 'start',
          }}
          className="cinfo-grid"
        >
          {/* Cards */}
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: .6 }}
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '1rem',
            }}
            className="cinfo-cards"
          >
            {INFO.map(({ icon: Icon, label, value, href, note, testid, color }) => (
              <div key={label} data-testid={testid || undefined}>
                {href ? (
                  <a
                    href={href}
                    style={{
                      textDecoration: 'none',
                      display: 'block',
                      height: '100%',
                    }}
                  >
                    <div
                      style={{
                        background: 'var(--card)',
                        border: '1px solid var(--border)',
                        borderRadius: 'var(--rl)',
                        padding: '1.25rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '.875rem',
                        height: '100%',
                        transition: 'all .2s',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = 'var(--border2)';
                        e.currentTarget.style.background = 'var(--card2)';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = 'var(--border)';
                        e.currentTarget.style.background = 'var(--card)';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}
                    >
                      <div
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: 10,
                          background: `${color}15`,
                          border: `1px solid ${color}30`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color,
                        }}
                      >
                        <Icon size={18} strokeWidth={1.75} />
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: '.72rem',
                            color: 'var(--muted)',
                            marginBottom: '.25rem',
                            fontWeight: 600,
                            letterSpacing: '.04em',
                            textTransform: 'uppercase',
                          }}
                        >
                          {label}
                        </div>
                        <div
                          style={{
                            fontFamily: "'Space Grotesk', sans-serif",
                            fontWeight: 700,
                            fontSize: '.95rem',
                            color: 'var(--text)',
                          }}
                          className="num"
                        >
                          {value}
                        </div>
                      </div>
                    </div>
                  </a>
                ) : (
                  <div
                    style={{
                      background: 'var(--card)',
                      border: '1px solid var(--border)',
                      borderRadius: 'var(--rl)',
                      padding: '1.25rem',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '.875rem',
                      height: '100%',
                    }}
                  >
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: 10,
                        background: `${color}15`,
                        border: `1px solid ${color}30`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color,
                      }}
                    >
                      <Icon size={18} strokeWidth={1.75} />
                    </div>
                    <div>
                      <div
                        style={{
                          fontSize: '.72rem',
                          color: 'var(--muted)',
                          marginBottom: '.25rem',
                          fontWeight: 600,
                          letterSpacing: '.04em',
                          textTransform: 'uppercase',
                        }}
                      >
                        {label}
                      </div>
                      <div
                        style={{
                          fontFamily: "'Space Grotesk', sans-serif",
                          fontWeight: 700,
                          fontSize: '.95rem',
                          color: 'var(--text)',
                        }}
                      >
                        {value}
                      </div>
                      {note && (
                        <div
                          style={{
                            fontSize: '.75rem',
                            color: 'var(--text2)',
                            marginTop: '.25rem',
                          }}
                        >
                          {note}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))}

            {/* Full-width CTA */}
            <div style={{ gridColumn: '1 / -1' }}>
              <a
                href={PHONES.main_tel}
                className="btn btn-primary btn-lg num ring"
                style={{
                  width: '100%',
                  justifyContent: 'center',
                  gap: '.75rem',
                }}
              >
                <Phone size={18} /> Hemen Ara — {PHONES.main}
              </a>
            </div>
          </motion.div>

          {/* Map */}
          <motion.div
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: .6, delay: .15 }}
          >
            <div className="map-wrap" data-testid="contact-map-iframe">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d192697.77967960754!2d29.70997539562064!3d40.776044208697!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cb8f5f8bc7bc8b%3A0x3fb5ac5f3b69219e!2sKocaeli!5e0!3m2!1str!2str!4v1705312547892!5m2!1str!2str"
                title="Kocaeli Haritası"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            <div
              style={{
                marginTop: '1.25rem',
                display: 'flex',
                gap: '.875rem',
                justifyContent: 'center',
              }}
            >
              <Link to="/iletisim" className="btn btn-ghost" style={{ gap: '.5rem' }}>
                <MapPin size={15} /> Detaylı İletişim
              </Link>
              <a
                href={CONTACT.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                data-gtm-action="whatsapp_click"
                className="btn btn-green"
                style={{ gap: '.5rem' }}
              >
                <MessageCircle size={15} /> WhatsApp
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      <style>{`
        @media(max-width: 768px) {
          .cinfo-grid {
            grid-template-columns: 1fr !important;
          }
          .cinfo-cards {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
}
